<template>
	<div class="element-wrapper text-left">
		<loading :active.sync="isLoading"></loading>

		<h6 class="element-header" v-if="headerShow">
			{{ t.user.add_balance }}
		</h6>

		<div class="os-tabs-controls">
			<ul class="nav nav-tabs upper mt-2 px-5">
				<li class="nav-item" v-for="type in transactionTypes">
					<a href="javascript:;" class="nav-link" v-on:click="changeType(type.val)" :class="(transactionType == type.val) ? 'active' : ''"> {{ type.name }}</a>
				</li>
			</ul>
		</div>

		<div class="element-box-tp">
			<p>
				<div class="row" v-if="transactionType == 2">
					<div class="col-sm-6 ">
						<div class="form-group">
							<label for="">{{ t.tranfer_from }}</label>
							<userAutoComplete :place="t.search_user" v-on:selected="selectFrom" />
						</div>
						<div class="users-list-w">
							<div class="user-w with-status" :class="(selectedFrom.online) ? 'status-green' : 'status-red'" v-if="selectedFrom">
								<div class="user-avatar-w">
									<div class="user-avatar">
										<img alt="" :src="api+'api/v1/users/get/profile_pic/'+selectedFrom.id"></div>
								</div>
								<div class="user-name">
									<h6 class="user-title">{{ selectedFrom.name }}</h6>
									<div class="user-role">{{ selectedFrom.username }}</div>
									<div class="user-role">{{ t.user.balance }}: {{ selectedFrom.balance | toMoney( selectedFrom.currency ) }}</div>
									<div class="user-role">{{ t.user.credit }}: {{ selectedFrom.credit | toMoney( selectedFrom.currency ) }}</div>
								</div>
								<a class="user-action" href="javascript:;">
									<div v-on:click="removeFrom(null)" class="os-icon os-icon-cancel-circle"></div>
								</a>
							</div>
						</div>
					</div>
					<div class="col-sm-6">
						<div class="form-group">
							<label for="">{{ t.tranfer_to }}</label>
							<userAutoComplete :place="t.search_user" v-on:selected="selectTo" />
						</div>

						<div class="users-list-w">
							<div class="user-w with-status" :class="(selectedTo.online) ? 'status-green' : 'status-red'" v-if="selectedTo">
								<div class="user-avatar-w">
									<div class="user-avatar">
										<img alt="" :src="api+'api/v1/users/get/profile_pic/'+selectedTo.id"></div>
								</div>
								<div class="user-name">
									<h6 class="user-title">{{ selectedTo.name }}</h6>
									<div class="user-role">{{ selectedTo.username }}</div>
									<div class="user-role">{{ t.user.balance }}: {{ selectedTo.balance | toMoney( selectedTo.currency ) }}</div>
									<div class="user-role">{{ t.user.credit }}: {{ selectedTo.credit | toMoney( selectedTo.currency ) }}</div>
								</div>
								<a class="user-action" href="javascript:;">
									<div v-on:click="removeTo(null)" class="os-icon os-icon-cancel-circle"></div>
								</a>
							</div>
						</div>
					</div>
				</div>
				<div class="row" v-if="transactionType == 1">
					<div class="col-12">
						<div class="form-group">
							<label for="">{{ t.tranfer_to }}</label>
							<userAutoComplete :place="t.search_user" v-on:selected="selectTo" />
						</div>

						<div class="users-list-w">
							<div class="user-w with-status" :class="(selectedTo.online) ? 'status-green' : 'status-red'" v-if="selectedTo">
								<div class="user-avatar-w">
									<div class="user-avatar">
										<img alt="" :src="api+'api/v1/users/get/profile_pic/'+selectedTo.id"></div>
								</div>
								<div class="user-name">
									<h6 class="user-title">{{ selectedTo.name }}</h6>
									<div class="user-role">{{ selectedTo.username }}</div>
									<div class="user-role">{{ t.user.balance }}: {{ selectedTo.balance | toMoney( selectedTo.currency ) }}</div>
									<div class="user-role">{{ t.user.credit }}: {{ selectedTo.credit | toMoney( selectedTo.currency ) }}</div>
								</div>
								<a class="user-action" href="javascript:;">
									<div v-on:click="removeTo(null)" class="os-icon os-icon-cancel-circle"></div>
								</a>
							</div>
						</div>
					</div>
				</div>
				<div class="row" v-if="getTo()">
					<div :class="(transactionType == 1) ? 'col-6' : 'col-12'" v-if="selectedTo">
						<div class="form-group">
							<label for="">{{ t.amount }}</label>
							<div class="input-group">
								<input class="form-control" v-model="amount" placeholder="Amount..." type="text" value="0.00">
								<div class="input-group-append">
									<div class="input-group-text">
										{{ selectedTo.currency.iso_code }}
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="col-6" v-if="selectedTo && transactionType == 1">
						<div class="form-group">
							<label for=""></label>
							<div class="input-group pt-1">
								<select class="form-control form-control-sm form-control-faded" v-model="transferType">
									<option v-for="option in transferTypes" v-bind:value="option.val">
										{{ option.name }}
									</option>
								</select>
							</div>
						</div>
					</div>
				</div>
				<div class="row" v-if="getTo() && transferType == 2">
					<div class="col-12">
						<div class="form-group">
							<label for="">{{ t.expiry_date }}</label>
							<div class="input-group">
								<date-picker :clearable="false" :not-before="new Date()" :format="session.date_time_format" :lang="t.times" v-model="expiryDate" :first-day-of-week="1"></date-picker>
							</div>
						</div>
					</div>

				</div>
				<div class="row" v-if="transactionType == 1 && getTo()">
					<div class="col-6" v-if="transferType == 1">
						<button class="btn btn-danger btn-block btn-lg" v-on:click="selectOperate('-')">- <span>{{ t.navigation.withdraw_money }}</span></button>
					</div>
					<div :class=" (transferType == 2) ? 'col-12': 'col-6'">
						<button class="btn btn-success btn-block btn-lg" v-on:click="selectOperate('+')">+ <span>{{ t.navigation.deposit_money }}</span></button>
					</div>
				</div>
				<div class="row" v-if="transactionType == 2 && getTo() && getFrom()">
					<div class="col-12">
						<button class="btn btn-primary btn-block btn-lg"  v-on:click="transferNow()"><i class="os-icon os-icon-refresh-ccw"></i><span>{{ t.transfer_now }}</span></button>
					</div>
				</div>

				<div class="row">
					<div class="col-12 pt-4">
						<div class="alert alert-success" v-for="r in response">
							{{ r }}
						</div>
						<div class="alert alert-danger" v-for="error in errors">
							{{ error }}
						</div>
					</div>
				</div>
			</p>
		</div>
	</div>
</template>

<script>
	import userAutoComplete from '@/components/autocomplete/userAutoComplete'
    import DatePicker from 'vue2-datepicker'

    export default {
        name: 'moneyTransfer',
	    components: { userAutoComplete, 'date-picker': DatePicker },
	    props: {
            uid: {
	            default: 0
            },
            headerShow: {
                default: 1
            }
	    },
        data () {
            return {
                api: window.api,
                t: this.$root.t,
	            session: this.$root.session,
	            transactionType: 1,
                transactionTypes: [
	                {name:  this.$root.t.transfer, val: 1},
                    {name:  this.$root.t.transfer_from_to, val: 2}
                ],
                transferType: 1,
	            transferTypes: [
                    {name:  this.$root.t.cash, val: 1},
                    {name:  this.$root.t.credit, val: 2}
	            ],
	            selectedTo: null,
                selectedFrom: null,
	            operate: '+',
	            amount: 0,
	            response: null,
                expiryDate: this.moment().add(5, 'days'),
	            errors: null,
                isLoading: false,
	            response: null,
	            userId: 0
            }
        },
	    watch: {
            '$route.query._mt_id' (o, n) {
                this.userId = n;
                this.setTo(n);
            },
		    'userId' (o, n) {
                this.setTo();
            },
            '$props.uid' (o, n) {
                this.setTo(o);
            }
	    },
	    mounted (){
			this.userId = this.uid;
	    },
	    methods: {
            transferNow () {
                this.transactionType = 2;
                this.transaction();
            },
            selectOperate (s) {
                this.transactionType = 1;
                this.operate = s;
                this.transaction();
            },
            selectTo (s) {
                if (this.getFrom() != s.id)
                {
                    this.selectedTo = s;
                }
            },
            selectFrom (s) {
                if (this.getTo() != s.id)
                {
                    this.selectedFrom = s;
                }
            },
            removeTo () {
                this.selectedTo = null;
            },
		    removeFrom () {
                this.selectedFrom = null;
		    },
            changeType (t) {
                this.transferType = 1;
                this.transactionType = t;
            },
		    getTo() {
                return (this.selectedTo) ? this.selectedTo.id : 0
		    },
            getFrom() {
                return (this.selectedFrom) ? this.selectedFrom.id : 0
            },
		    setTo(id) {
                var id = (id) ? id : this.userId ;

                this.$http.get(api+'api/v1/user/'+id).then(response => {
                    // get body data
                    this.selectedTo = response.body.result;

                }, response => {

                })

		    },
            setFrom(id) {
                var id = (id) ? id : this.$route.query._mt_id;
                this.$http.get(api+'api/v1/user/'+id).then(response => {
                    // get body data
                    this.selectedFrom = response.body.result;

                }, response => {

                })
            },
            transaction () {
                this.isLoading = true;
                this.$http.post(api+'api/v1/user/transaction/money_transfer',  {mode: this.transactionType, type: this.transferType, amount: this.amount, operate: this.operate,to: this.getTo(), from: this.getFrom(), expiryDate: this.moment(this.expiryDate).utc().format("YYYY-MM-DD HH:mm:ss")} ).then(response => {
                    // get body data
                    this.response = response.body.result;
                    this.errors = response.body.error;

                    this.setTo(this.getTo());
                    this.setFrom(this.getFrom());


                    this.isLoading = false;

                }, response => {
                    this.errors = response.body.error;
                    this.isLoading = false;
                })

                setTimeout(() => {
                    this.errors = null;
                this.response = null;
                },5000);
		    }
	    }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.nav.upper {

	}
</style>



// WEBPACK FOOTER //
// src/components/accounting/moneyTransfer.vue